var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.823 3.313l.72-.718c.765-.764 2.1-.764 2.864 0l-.002-.002c.765.765.765 2.1 0 2.865l-.718.72-2.864-2.865zM3.165 14.464l1.976.396.396 1.976-3.163.79.791-3.162zm2.498-1.54l-1.209-.242 7.955-7.954.726.726-7.472 7.47zm1.414 1.415l7.471-7.472.726.724-7.955 7.955-.242-1.207zM18.821 1.18c-.76-.76-1.77-1.177-2.847-1.177-1.074 0-2.086.417-2.846 1.179L1.72 12.59c-.128.128-.219.288-.263.464L.03 18.759c-.084.34.016.701.264.948.247.25.61.35.95.264l5.704-1.427c.175-.043.336-.134.464-.262l11.41-11.41c.76-.76 1.177-1.771 1.177-2.845 0-1.076-.418-2.088-1.179-2.848l.002.002z",
    transform: "translate(-1105 -944) translate(1089 936) translate(16 8) translate(6 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.8ad64ab8b2a178ca0f5e1366780557a2.svg";
export { ForwardRef as ReactComponent };